import { render, staticRenderFns } from "./RetailerShortageItemsTable.vue?vue&type=template&id=121ffc19&scoped=true&"
import script from "./RetailerShortageItemsTable.vue?vue&type=script&lang=js&"
export * from "./RetailerShortageItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./RetailerShortageItemsTable.vue?vue&type=style&index=0&id=121ffc19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121ffc19",
  null
  
)

export default component.exports